export default function () {
  $('.opportunity-status-change a').click(function() {
    var status = $(this).data('status');
    var url = $(this).parents('.opportunity-status-change').data('url');

    $.ajax({
      url: url,
      type: 'post',
      data: {
        status: status,
      },
      success: function (data) {
        window.location.reload();
      }
    });

    return false;
  });

  $('.follow-up-done').click(function() {
    $.ajax({
      url: $(this).attr('href'),
      type: 'post',
      success: function (data) {
        window.location.reload();
      }
    });

    return false;
  });
};



// WEBPACK FOOTER //
// ./assets/js/leads.js